import React from 'react';
import { useLanguage } from '../LanguageProvider';

export function ContactKvkk() {
  const { language } = useLanguage();
  const texts = {
    tr: {
      title: 'İletişim Formu KVKK Aydınlatma Metni',
      intro:
        '6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, İlimera Teknoloji Yazılım LTD. ŞTİ. ("İlimera" veya "Şirket") olarak iletişim formu üzerinden ilettiğiniz kişisel verilerinizi aşağıda açıklanan amaçlar ve hukuki sebepler doğrultusunda işlemekteyiz.',
      processedTitle: 'İşlenen Kişisel Veriler',
      processedData: 'Ad-soyad, e‑posta, telefon, konu ve mesaj içeriği.',
      purposesTitle: 'İşleme Amaçları',
      purposes: [
        'Taleplerinize dönüş yapılması ve iletişimin sağlanması',
        'Tekliflendirme ve müşteri ilişkileri süreçlerinin yürütülmesi',
        'Hukuki yükümlülüklerin yerine getirilmesi ve olası uyuşmazlıklarda ispat',
      ],
      legalTitle: 'Hukuki Sebepler',
      legalBody:
        'KVKK m.5/2 (c), (ç) ve (f): sözleşmenin kurulması/ifası, hukuki yükümlülük, meşru menfaat. Pazarlama/iletişim izni vermeniz halinde KVKK m.5/1 kapsamında açık rızanız.',
      transfersTitle: 'Aktarımlar',
      transfersBody:
        'Barındırma, e‑posta/SMS ve BT altyapı hizmeti sağlayıcıları ile sınırlı olarak paylaşılabilir; yasal talepler halinde yetkili mercilere aktarılabilir.',
      retentionTitle: 'Saklama Süresi',
      retentionBody: 'İşleme amacının gerektirdiği süre ve ilgili mevzuattaki zamanaşımı süreleri boyunca.',
      rightsTitle: 'Haklarınız',
      rightsBody: 'KVKK m.11 kapsamındaki haklarınızı kullanmak için bizimle iletişime geçebilirsiniz.',
      contactTitle: 'İletişim',
      contactLines: [
        '<strong>Unvan:</strong> İlimera Teknoloji Yazılım LTD. ŞTİ.',
        '<strong>E‑posta:</strong> info@ilimera.com',
        '<strong>Genel Merkez:</strong> Akdeniz Üniversitesi, Teknokent Uluğbey ArGe-2 No:3A/B96 Konyaaltı / ANTALYA',
        '<strong>Ar-Ge Merkezi:</strong> Davraz Mah. 104. Cadde No:44-A Kat:2 Ofis:13/1, Merkez / ISPARTA',
      ],
      disclaimer:
        'Bu metin bilgilendirme amaçlıdır; güncel mevzuat ve şirket süreçlerinize göre hukuk danışmanınızla gözden geçirmenizi öneririz.',
    },
    en: {
      title: 'Contact Form GDPR Information Notice',
      intro:
        'Under the Turkish Data Protection Law No. 6698 ("KVKK"), İlimera Teknoloji Yazılım LTD. ŞTİ. ("İlimera" or "Company") processes personal data you submit via the contact form for the purposes and legal bases set out below.',
      processedTitle: 'Personal Data Processed',
      processedData: 'Name, email, phone, subject, and message content.',
      purposesTitle: 'Processing Purposes',
      purposes: [
        'Responding to your requests and maintaining communication',
        'Conducting quotation and customer relationship processes',
        'Fulfilling legal obligations and providing evidence in potential disputes',
      ],
      legalTitle: 'Legal Basis',
      legalBody:
        'KVKK Art. 5/2 (c), (ç), and (f): formation/performance of contract, legal obligation, legitimate interest. If you grant marketing/communication consent, your explicit consent under KVKK Art. 5/1.',
      transfersTitle: 'Transfers',
      transfersBody:
        'May be shared with hosting, email/SMS, and IT infrastructure service providers on a limited basis; may be transferred to authorized authorities upon legal requests.',
      retentionTitle: 'Retention Period',
      retentionBody: 'For the period required by the processing purpose and the statute of limitations under applicable legislation.',
      rightsTitle: 'Your Rights',
      rightsBody: 'You may contact us to exercise your rights under KVKK Art. 11.',
      contactTitle: 'Contact',
      contactLines: [
        '<strong>Company:</strong> İlimera Teknoloji Yazılım LTD. ŞTİ.',
        '<strong>Email:</strong> info@ilimera.com',
        '<strong>Head Office:</strong> Akdeniz Üniversitesi, Teknokent Uluğbey ArGe-2 No:3A/B96 Konyaaltı / ANTALYA',
        '<strong>R&D Center:</strong> Davraz Mah. 104. Cadde No:44-A Kat:2 Ofis:13/1, Merkez / ISPARTA',
      ],
      disclaimer:
        'This text is for informational purposes; we recommend reviewing it with your legal counsel according to current legislation and your company processes.',
    },
  } as const;

  const t = texts[language] ?? texts.tr;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold mb-6">{t.title}</h1>
      <p className="text-muted-foreground mb-4">{t.intro}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">{t.processedTitle}</h2>
      <p className="mb-4">{t.processedData}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">{t.purposesTitle}</h2>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        {t.purposes.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">{t.legalTitle}</h2>
      <p className="mb-4">{t.legalBody}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">{t.transfersTitle}</h2>
      <p className="mb-4">{t.transfersBody}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">{t.retentionTitle}</h2>
      <p className="mb-4">{t.retentionBody}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">{t.rightsTitle}</h2>
      <p className="mb-4 text-sm">{t.rightsBody}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">{t.contactTitle}</h2>
      <div className="space-y-3 text-sm">
        {t.contactLines.map((line, idx) => (
          <div key={idx} dangerouslySetInnerHTML={{ __html: line }} />
        ))}
      </div>

      <p className="text-xs text-muted-foreground mt-8">{t.disclaimer}</p>
    </div>
  );
}


